var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGetReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 24C29.5128 24 29.9355 24.386 29.9933 24.8834L30 25V27C30 28.5977 28.7511 29.9037 27.1763 29.9949L27 30H13C11.4023 30 10.0963 28.7511 10.0051 27.1763L10 27V25C10 24.4477 10.4477 24 11 24C11.5128 24 11.9355 24.386 11.9933 24.8834L12 25V27C12 27.5128 12.386 27.9355 12.8834 27.9933L13 28H27C27.5128 28 27.9355 27.614 27.9933 27.1166L28 27V25C28 24.4477 28.4477 24 29 24ZM20 10C20.5523 10 21 10.4477 21 11V20.585L22.2929 19.2929C22.6534 18.9324 23.2206 18.9047 23.6129 19.2097L23.7071 19.2929C24.0676 19.6534 24.0953 20.2206 23.7903 20.6129L23.7071 20.7071L20.7071 23.7071L20.6631 23.7485L20.5953 23.8037L20.4841 23.8753L20.3713 23.9288L20.266 23.9642L20.1175 23.9932L20 24L19.9248 23.9972L19.7993 23.9798L19.6879 23.9503L19.5768 23.9063L19.4793 23.854L19.3833 23.7872C19.3515 23.7623 19.3214 23.7356 19.2929 23.7071L16.2929 20.7071C15.9024 20.3166 15.9024 19.6834 16.2929 19.2929C16.6534 18.9324 17.2206 18.9047 17.6129 19.2097L17.7071 19.2929L19 20.585V11C19 10.4477 19.4477 10 20 10Z",
    fill: "#171718"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#F04528"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetReportIcon);
export default __webpack_public_path__ + "static/media/get-report-icon.11f6a0609ff4f6152db4052885f65756.svg";
export { ForwardRef as ReactComponent };